import { reportUiFailure } from "$lib/report-failure.js";

let problem: string | undefined;
const listeners = new Set<(message: string) => void>();
export const desktopCredentialProblem = () => problem;
export function followDesktopCredentialProblem(callback: (message: string) => void): () => void {
  listeners.add(callback);
  return () => listeners.delete(callback);
}
export function desktopCredentials() {
  return typeof window === "undefined" ? undefined : window.cyborg7Desktop?.credentials;
}
export function credentialUnavailable(report = true): never {
  const message =
    "Your saved desktop sign-in could not be read or saved. Unlock your keychain and try again. Your saved credential has been kept.";
  if (!problem) {
    problem = message;
    if (report)
      reportUiFailure("auth.desktop_credential", new Error("desktop credential unavailable"));
    for (const notify of listeners) notify(message);
  }
  throw new Error(message);
}
export function readDesktopCredential() {
  const bridge = desktopCredentials();
  if (!bridge) return undefined;
  if (problem) credentialUnavailable();
  let read: ReturnType<typeof bridge.read>;
  try {
    read = bridge.read();
  } catch {
    // intentional: credentialUnavailable reports this IPC transport failure once.
    return credentialUnavailable();
  }
  if (read.status === "undecryptable" || read.status === "refused") credentialUnavailable(false);
  return read;
}
export function persistDesktopCredential(url: string, token: string, refreshToken?: string): void {
  const bridge = desktopCredentials();
  if (!bridge) return;
  const existing = readDesktopCredential();
  const previous =
    existing?.status === "ok" && existing.value.url === url && existing.value.token === token
      ? existing.value.refreshToken
      : undefined;
  const refresh = refreshToken ?? previous;
  let status: string;
  try {
    status = bridge.write({ url, token, ...(refresh ? { refreshToken: refresh } : {}) }).status;
  } catch {
    // intentional: credentialUnavailable reports this IPC transport failure once.
    credentialUnavailable();
  }
  if (status !== "ok") credentialUnavailable(false);
}
export function clearDesktopCredential(): void {
  const bridge = desktopCredentials();
  if (!bridge) return;
  if (problem) credentialUnavailable(false);
  let status: string;
  try {
    status = bridge.clear().status;
  } catch {
    // intentional: credentialUnavailable reports this IPC transport failure once.
    credentialUnavailable();
  }
  if (status !== "ok") credentialUnavailable(false);
}
